import api from '../services/ApiService';
import store from '../store';

export const BUILD_LIST = 'BUILD_LIST';
export const START_BUILD_LIST = 'START_BUILD_LIST';


export function buildList(pageName, command, key = '') {
  let listKey = `${pageName}:${command}`;

  // TODO Do we still need this? What still relies on it?
  if (key) {
    listKey += `.${key}`;
  }

  return {
    type: BUILD_LIST,
    payload: api.put(`list/${pageName}/build`, {}, {
      params: {
        cmd: command,
        key,
      },
    }),
    meta: {
      listKey,
    },
  };
}

export function startBuildList(pageName, command, key = '') {
  let listKey = `${pageName}:${command}`;
  if (key) {
    listKey += `.${key}`;
  }

  return {
    type: START_BUILD_LIST,
    listKey,
    building: store.getState().list.building, // return building state for caller
  };
}
